'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _capitalize = require('../../utils/capitalize');

var _capitalize2 = _interopRequireDefault(_capitalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DISTANCE_FROM_TOOLTIP_MARKER = 35;
var ARROW_DISTANCE_FROM_MARKER = 17;

var TooltipTextBubble = function (_PureComponent) {
  _inherits(TooltipTextBubble, _PureComponent);

  function TooltipTextBubble() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TooltipTextBubble);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltipTextBubble.__proto__ || Object.getPrototypeOf(TooltipTextBubble)).call.apply(_ref, [this].concat(args))), _this), _this.state = { show: false, position: { x: null, y: null } }, _this.dimensions = { width: 0, height: 0 }, _this.onContainerRef = function (ref) {
      _this.containerNode = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TooltipTextBubble, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.componentRef(this);

      var _containerNode$getBou = this.containerNode.getBoundingClientRect(),
          width = _containerNode$getBou.width,
          height = _containerNode$getBou.height;

      this.dimensions = { width: width, height: height };
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref2;

      var _props = this.props,
          verticalAlignment = _props.verticalAlignment,
          horizontalAlignment = _props.horizontalAlignment,
          backgroundColor = _props.backgroundColor,
          arrowClassName = _props.arrowClassName,
          contentClassName = _props.contentClassName,
          className = _props.className;
      var _state = this.state,
          position = _state.position,
          show = _state.show;

      var classNames = 'luna-tooltip ' + (show ? 'is-active' : '');
      var bubblePosition = this.calculateBubblePosition(position, { verticalAlignment: verticalAlignment, horizontalAlignment: horizontalAlignment });
      var arrowPosition = this.calculateArrowPosition(position, { verticalAlignment: verticalAlignment, horizontalAlignment: horizontalAlignment });
      return _react2.default.createElement(
        'div',
        { ref: this.onContainerRef, className: classNames + ' ' + className, style: {
            backgroundColor: backgroundColor,
            top: bubblePosition.y,
            left: bubblePosition.x
          } },
        _react2.default.createElement('span', { className: 'luna-tooltipArrow ' + arrowClassName, style: (_ref2 = {
            border: '10px solid transparent'
          }, _defineProperty(_ref2, 'border' + (0, _capitalize2.default)(verticalAlignment) + 'Color', backgroundColor), _defineProperty(_ref2, 'top', arrowPosition.y), _defineProperty(_ref2, 'left', arrowPosition.x), _ref2) }),
        _react2.default.createElement(
          'span',
          { className: contentClassName },
          this.props.children
        )
      );
    }
  }, {
    key: 'calculateBubblePosition',
    value: function calculateBubblePosition(iconPosition, _ref3) {
      var verticalAlignment = _ref3.verticalAlignment,
          horizontalAlignment = _ref3.horizontalAlignment;

      var offsetedContent = this.dimensions.width * 0.1;
      var alignmentCoefficient = horizontalAlignment === 'left' ? -1 : 0;
      var verticalCoefficient = verticalAlignment === 'bottom' ? 1 : -0.5; // in all honesty, no clue why the -0.5...
      var contentCoefficient = verticalAlignment === 'top' ? -1 : 0;
      return {
        x: iconPosition.x - offsetedContent + this.dimensions.width * 0.8 * alignmentCoefficient,
        y: iconPosition.y + verticalCoefficient * DISTANCE_FROM_TOOLTIP_MARKER + contentCoefficient * this.dimensions.height
      };
    }
  }, {
    key: 'calculateArrowPosition',
    value: function calculateArrowPosition(iconPosition, _ref4) {
      var horizontalAlignment = _ref4.horizontalAlignment,
          verticalAlignment = _ref4.verticalAlignment;

      var horizontalCoefficient = verticalAlignment === 'bottom' ? 1 : -1;
      return {
        x: iconPosition.x,
        y: iconPosition.y + horizontalCoefficient * ARROW_DISTANCE_FROM_MARKER
      };
    }
  }]);

  return TooltipTextBubble;
}(_react.PureComponent);

TooltipTextBubble.propTypes = {
  verticalAlignment: _propTypes2.default.oneOf(['top', 'bottom']),
  horizontalAlignment: _propTypes2.default.oneOf(['left', 'right']),
  backgroundColor: _propTypes2.default.string,
  arrowClassName: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  componentRef: _propTypes2.default.func.isRequired
};
TooltipTextBubble.defaultProps = {
  verticalAlignment: 'bottom',
  horizontalAlignment: 'right',
  backgroundColor: '#5ab1fe',
  className: '',
  arrowClassName: '',
  contentClassName: undefined
};
exports.default = TooltipTextBubble;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Tooltip/TextBubble.js